// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 652) return "vendor-redux.min.js";
	if (chunkId === 525) return "common-components.min.js";
	if (chunkId === 619) return "vendor-others.min.js";
	if (chunkId === 786) return "vendor-swiper.min.js";
	// return url for filenames based on template
	return "chunks/chunk-" + chunkId + "-" + {"2":"312933b4cc8510f1a118","151":"bdac79dc2af5638c6112","195":"f585fba4f1e120a16c84","233":"e0f550e4f8b34c570631","289":"bc5bba6b9ae0907423cf","304":"3caeb966aefbf6ebb4af","460":"edb7f44922605f194ccd","500":"84995535ea7551a4cec6","515":"0d1d10e7e4a5aab29249","568":"998c055ae25a5254d7d2","801":"c02960b0161b08f68779","872":"00aebb31ded15466f84c","909":"6d42fd9c6f8266a9a49c"}[chunkId] + ".min.js";
};